import { init, replayIntegration, browserTracingIntegration } from '@sentry/remix';
import { RemixBrowser, useLocation, useMatches } from '@remix-run/react';
import { startTransition, StrictMode, useEffect } from 'react';
import { hydrateRoot } from 'react-dom/client';

const EXCLUDED_ERROR_MESSAGES = [
  // Expected after deployments: browser has stale Remix manifest, auto-reloads, no user impact
  'Detected manifest version mismatch, reloading...',
];

init({
  environment: import.meta.env.VITE_SENTRY_ENVIRONMENT,
  dsn: import.meta.env.VITE_SENTRY_DSN,
  tracesSampleRate: 1,

  integrations: [
    browserTracingIntegration({
      useEffect,
      useLocation,
      useMatches,
    }),
    replayIntegration({
      maskAllText: true,
      blockAllMedia: true,
    }),
  ],

  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1,

  beforeSend(event) {
    const exceptionMessage = event.exception?.values?.[0]?.value;
    if (exceptionMessage && EXCLUDED_ERROR_MESSAGES.includes(exceptionMessage)) {
      return null;
    }
    return event;
  },
});

startTransition(() => {
  hydrateRoot(
    document,
    <StrictMode>
      <RemixBrowser />
    </StrictMode>,
  );
});
